export default __webpack_public_path__ + "static/media/hubs-children-icon.3189f25a.svg";